import { getQueryFields } from 'helpers/graphql'
import { getEntityGraphql, getEntityQuery } from 'services/api/utils'
import type { Options } from 'types/common'

const queryDomain = 'userGroups'

const getUsersGroupFields = getQueryFields({
  'value:name': true,
  label: true,
  preferredRole: true,
  upAuthSuSession: true,
})

const GET_USER_GROUP_QUERY_NAME = 'byName'

const GET_USER_GROUP_QUERY_IDENTIFIER = 'name'

const getUserGroupQuery = getEntityQuery({
  queryDomain,
  identifier: GET_USER_GROUP_QUERY_IDENTIFIER,
  identifierFormat: 'String!',
  getFieldsFn: getUsersGroupFields,
  queryName: GET_USER_GROUP_QUERY_NAME,
})

export const getUserGroup = getEntityGraphql({
  queryDomain,
  identifier: GET_USER_GROUP_QUERY_IDENTIFIER,
  getQueryFn: getUserGroupQuery,
  queryName: GET_USER_GROUP_QUERY_NAME,
})

const LIST_USER_GROUPS_QUERY_NAME = 'all'

// listUserGroups is a non-relay style query
const getUserGroupsQuery = getEntityQuery({
  queryDomain,
  identifier: null,
  getFieldsFn: getUsersGroupFields,
  queryName: LIST_USER_GROUPS_QUERY_NAME,
})

export const listUserGroups = getEntityGraphql<Options<string>>({
  queryDomain,
  postProcessFn: null,
  getFieldsFn: getUsersGroupFields,
  queryName: LIST_USER_GROUPS_QUERY_NAME,
  getQueryFn: getUserGroupsQuery,
  omitFields: ['upAuthSuSession', 'preferredRole'],
  queryDisplayName: 'GetAllUserGroupsQuery',
})
